"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const query_string_1 = require("query-string");
/**
 * Mutates a location object to use the query parameters passed in
 */
function mergeLocationQueryOrSearch(location, newQuery) {
    let newLocation;
    // if location.query exists, update the query in location.
    // otherwise update the search string
    if (location.query) {
        newLocation = Object.assign({}, location, { query: newQuery, search: '' });
    }
    else {
        // replace location.search
        const queryStr = query_string_1.stringify(newQuery);
        const search = queryStr.length ? `?${queryStr}` : '';
        newLocation = Object.assign({}, location, { search });
    }
    // update react router key
    newLocation.key = `${Date.now()}`;
    return newLocation;
}
/**
 * remove query params that are nully or an empty strings.
 * note: these values are assumed to be already encoded as strings.
 */
function filterNully(query) {
    const filteredQuery = Object.keys(query).reduce((queryAccumulator, queryParam) => {
        // get encoded value for this param
        const encodedValue = query[queryParam];
        // if it isn't null or empty string, add it to the accumulated obj
        if (encodedValue != null && encodedValue !== '') {
            queryAccumulator[queryParam] = encodedValue;
        }
        return queryAccumulator;
    }, {});
    return filteredQuery;
}
/**
 * Update a location, wiping out parameters not included in newQuery
 */
function updateLocation(newQuery, location) {
    return mergeLocationQueryOrSearch(location, filterNully(newQuery));
}
/**
 * Update a location while retaining existing parameters
 */
function updateInLocation(queryReplacements, location) {
    // if a query is there, use it, otherwise parse the search string
    const currQuery = location.query || query_string_1.parse(location.search);
    const newQuery = Object.assign({}, currQuery, queryReplacements);
    return updateLocation(filterNully(newQuery), location);
}
/**
 * Updates the URL to match the specified query changes.
 * If replaceIn or pushIn are used as the updateType, then parameters
 * not specified in queryReplacements are retained. If replace or push
 * are used, only the values in queryReplacements will be available.
 */
function updateUrlQuery(queryReplacements, location, history, updateType = 'replaceIn') {
    switch (updateType) {
        case 'replaceIn':
            history.replace(updateInLocation(queryReplacements, location));
            break;
        case 'pushIn':
            history.push(updateInLocation(queryReplacements, location));
            break;
        case 'replace':
            history.replace(updateLocation(queryReplacements, location));
            break;
        case 'push':
            history.push(updateLocation(queryReplacements, location));
            break;
        default:
    }
}
exports.updateUrlQuery = updateUrlQuery;
exports.default = updateUrlQuery;
